<script setup>
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value)

const props = defineProps({
    stateKey: {
        type: String,
    },
    responseError: {
        type: Object, 
        default: () => ({ active: false, text: '' })
    }
})
</script>
<template>
    <label :class="['checkbox', isTouched && (isValid ? 'valid' : 'not-valid') ]">
        <div class="checkbox__inner">
            <input 
                type="checkbox" 
                class="checkbox__real-input"
                @change="storeField.updateFields(stateKey, 'title', value), validation(stateKey)" 
                v-model="value"
            >
            <span class="checkbox__custom-input"></span>
            <span class="checkbox__text">
                <slot></slot> 
            </span>
        </div>
        <Transition mode="out-in">
            <span v-if="!!textError" class="input__error">{{ textError }}</span>
        </Transition>
    </label>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.checkbox {
    display: grid;
    gap: .5rem;
    padding: 14px 0;
}
.checkbox__inner {
    display: flex;
    align-items: start;
    gap: 1.6rem;

}
.checkbox__real-input {
	width: 0;
	height: 0;
	opacity: 0;
	position: absolute;
	z-index: -1;
}

.checkbox__custom-input {
    display: flex;
    align-items: center;
    justify-self: center;
    position: relative;
    border: 1px solid var(--native-hint-color);
    border-radius: 0.5rem;
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
    background-color: transparent;
    transition:  var(--transition) ease-in;   
}
.checkbox__text {
    font-family: var(--second-family);
    font-weight: 400;
    font-size: 1.5rem;
    line-height: 133%;
    letter-spacing: 0.7px;
    color: var(--native-text-color);
    a {
        border-bottom: .1rem solid transparent;
        color: var(--native-link-color);
        @media (hover: hover){
            &:hover {
                border-color: currentColor;
            }
        }
    }
}

.checkbox__custom-input::before {
	content: '';	
    display: block;
	width: 1.2rem;
	height: 1rem;
	background-image: url('@/assets/img/icons/check.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
	position: absolute;
    transform: scale(0);
    
    transition: 0.2s ease-in; 
    @media (max-width: vars.$x480) {
        // width: 2rem;
        // height: 2rem;
    } 
}
.checkbox__real-input:checked + .checkbox__custom-input {
	background: var(--native-link-color);
    border: 1px solid var(--native-link-color);
}
.checkbox__real-input:checked + .checkbox__custom-input::before {
	transform: scale(1) translateX(3px);
}
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
    transform: translateX(20px);
}
.v-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}
</style>@/stores/storeFieldData